import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import QueuePage from './pages/Queue';
import Checkin from './pages/Checkin';
import Demo from './pages/Demo';
import Admin from './pages/Admin';
import QRCheckin from './pages/QRCheckin';
import InfoTainment from './pages/InfoTainment';
import DJDashboard from './pages/DJDashboard';
import Profile from './pages/Profile';
import GymRules from './pages/GymRules';
import ColorshadeMeaning from './pages/ColorshadeMeaning';
import AdminPage from './pages/AdminPage';
import HelpDeskInfo from './pages/HelpDeskInfo';
import Selfservice from './pages/Selfservice';
import Trainers from './pages/Trainers';
import CoffeeMenu from './pages/coffee/coffeemenu';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <InfoTainment /> },
        { path: 'superadminpage/runwayuser', element: <UserPage /> },
        { path: 'adminpage', element: <AdminPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'queue', element: <QueuePage /> },
        { path: 'demo', element: <Demo /> },
        { path: 'checkin', element: <Checkin /> },
        { path: 'infotainment', element: <InfoTainment /> },
        { path: 'helpdesk', element: <HelpDeskInfo /> },
        { path: 'admin', element: <Admin /> },
        { path: 'qrcheckin', element: <QRCheckin /> },
        { path: 'userprofile/:mode', element: <Profile /> },
        { path: 'userprofile', element: <Profile /> },
        { path: 'inbody', element: <Profile /> },
        { path: 'selfservice', element: <Selfservice /> },
        { path: 'selfservice/:service', element: <Selfservice /> },
        { path: 'edituserprofile', element: <Profile /> },
        { path: 'djdashboard', element: <DJDashboard /> },
        { path: 'demopage', element: <DashboardAppPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'gymrules',
      element: <GymRules />,
    },
    {
      path: 'trainers',
      element: <Trainers />,
    },
    {
      path: 'coffeemenu',
      element: <CoffeeMenu />,
    },
    {
      path: 'colorshade',
      element: <ColorshadeMeaning />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
